import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import FilterForm from '../../../commons/FilterForm';
import useStyles from './styles';
import ProductsTable from './ProductsTable';
import DeleteButton from '../../../commons/DeleteButton';
import GenericConfirmationModal from '../../../commons/GenericConfirmationModal';

export default function Products({
  modals,
  fetchProductsData,
  deleteContent,
}) {
  const [page, setPage] = React.useState(0);
  const classes = useStyles();

  return (
    <Box>
      <Box className={classes.filtersWrapper}>
        <FilterForm filterName="productGroup.number" fetchBy={fetchProductsData} label="Number" setPage={setPage} />
        <FilterForm filterName="partNumber" fetchBy={fetchProductsData} label="Part" setPage={setPage} />
        <FilterForm filterName="description" fetchBy={fetchProductsData} label="Description" setPage={setPage} />
        <DeleteButton destination="products" modal="deleteAllProducts" />
        {modals.deleteAllProducts
        && (
        <GenericConfirmationModal
          confirmationType="deleteAllProducts"
          confirmedFunction={() => deleteContent('products')}
          informationalHeader="You are going to remove all products"
        />
        )}
      </Box>
      <ProductsTable page={page} setPage={setPage} />
    </Box>
  );
}

Products.propTypes = {
  modals: PropTypes.objectOf(PropTypes.bool).isRequired,
  fetchProductsData: PropTypes.func.isRequired,
  deleteContent: PropTypes.func.isRequired,
};
